import React, { useState } from "react";

const codeProblems = [
    {
        buggyCode: `function sum(a, b) {
  return a + b
}`,
        error: "Manca il punto e virgola",
        fixed: `function sum(a, b) {
  return a + b;
}`,
        hint: "Dopo il return manca qualcosa..."
    },
    {
        buggyCode: `const arr = [1, 2, 3];
arr.map(x => x * 2)`,
        error: "Risultato non salvato",
        fixed: `const arr = [1, 2, 3];
const doubled = arr.map(x => x * 2);`,
        hint: "Il risultato di map() non viene assegnato"
    },
    {
        buggyCode: `if (x = 10) {
  console.log("ok");
}`,
        error: "Usato = invece di ===",
        fixed: `if (x === 10) {
  console.log("ok");
}`,
        hint: "Attenzione all'operatore di confronto"
    },
    {
        buggyCode: `const obj = {
  name: "Test"
  age: 25
}`,
        error: "Manca la virgola",
        fixed: `const obj = {
  name: "Test",
  age: 25
}`,
        hint: "Tra le proprietà dell'oggetto serve qualcosa"
    },
    {
        buggyCode: `function greet(name) {
  console.log("Ciao" + name);
}`,
        error: "Manca lo spazio",
        fixed: `function greet(name) {
  console.log("Ciao " + name);
}`,
        hint: "Il saluto risulterà attaccato al nome"
    }
];

export default function SyntaxFix() {
    const [currentProblem, setCurrentProblem] = useState(0);
    const [userCode, setUserCode] = useState("");
    const [showHint, setShowHint] = useState(false);
    const [showSolution, setShowSolution] = useState(false);
    const [score, setScore] = useState(0);
    const [started, setStarted] = useState(false);
    const [feedback, setFeedback] = useState("");
    const [attemptedFix, setAttemptedFix] = useState(false);

    const startGame = () => {
        setStarted(true);
        setCurrentProblem(0);
        setScore(0);
        setShowHint(false);
        setShowSolution(false);
        setUserCode(codeProblems[0].buggyCode);
        setFeedback("");
        setAttemptedFix(false);
    };

    const checkUserFix = () => {
        setAttemptedFix(true);
        // Normalizza gli spazi per il confronto
        const normalizedUser = userCode.replace(/\s+/g, ' ').trim();
        const normalizedFixed = codeProblems[currentProblem].fixed.replace(/\s+/g, ' ').trim();

        if (normalizedUser === normalizedFixed) {
            const points = showHint ? 0.5 : 1;
            setScore(score + points);
            setFeedback("✓ Corretto!");

            setTimeout(() => {
                if (currentProblem + 1 < codeProblems.length) {
                    setCurrentProblem(currentProblem + 1);
                    setShowHint(false);
                    setShowSolution(false);
                    setUserCode(codeProblems[currentProblem + 1].buggyCode);
                    setFeedback("");
                    setAttemptedFix(false);
                } else {
                    setShowSolution(false);
                }
            }, 1500);
        } else {
            setFeedback("✗ Non ancora corretto, riprova!");
            setTimeout(() => setFeedback(""), 2000);
        }
    };

    const showCorrectSolution = () => {
        setShowSolution(true);
        setUserCode(codeProblems[currentProblem].fixed);
        const points = showHint ? 0.25 : 0.5;
        setScore(score + points);

        setTimeout(() => {
            if (currentProblem + 1 < codeProblems.length) {
                setCurrentProblem(currentProblem + 1);
                setShowHint(false);
                setShowSolution(false);
                setUserCode(codeProblems[currentProblem + 1].buggyCode);
                setFeedback("");
                setAttemptedFix(false);
            }
        }, 2500);
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-bug" style={{marginRight:"6px"}}></i> Syntax Fix
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"0.5rem"}}>
                    Trova e correggi gli errori nel codice!
                </p>
                <p style={{fontSize:"0.75rem", marginBottom:"1rem", color:"#94a3b8"}}>
                    Modifica il codice direttamente nell'editor
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (currentProblem >= codeProblems.length && started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Debug Completato!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#22c55e", marginBottom:"1rem"}}>
                    {score.toFixed(1)}/{codeProblems.length} punti
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {score === codeProblems.length && "🎉 Debugger perfetto!"}
                    {score >= 3 && score < codeProblems.length && "👍 Ottimo occhio!"}
                    {score < 3 && "🐛 Continua a esercitarti!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    const problem = codeProblems[currentProblem];

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{marginBottom:"1rem", color:"#94a3b8", fontSize:"0.85rem"}}>
                Bug {currentProblem + 1} di {codeProblems.length} - Punteggio: {score.toFixed(1)}
            </div>

            <h4 style={{color:"#ef4444", marginBottom:"1rem", fontSize:"0.9rem"}}>
                <i className="fas fa-exclamation-triangle" style={{marginRight:"6px"}}></i>
                Trova e correggi l'errore:
            </h4>

            <textarea
                value={userCode}
                onChange={(e) => setUserCode(e.target.value)}
                disabled={showSolution}
                style={{
                    width:"100%",
                    minHeight:"120px",
                    background:"rgba(0,0,0,0.4)",
                    padding:"0.8rem",
                    borderRadius:"0.5rem",
                    fontSize:"0.75rem",
                    color:"#00ffa3",
                    marginBottom:"1rem",
                    fontFamily:"monospace",
                    border: attemptedFix && feedback.includes("✓")
                        ? "2px solid #22c55e"
                        : attemptedFix && feedback.includes("✗")
                            ? "2px solid #ef4444"
                            : "2px solid rgba(239,68,68,0.3)",
                    outline:"none",
                    resize:"vertical"
                }}
                placeholder="Correggi il codice qui..."
            />

            {feedback && (
                <div style={{
                    padding:"0.6rem",
                    background: feedback.includes("✓") ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.2)",
                    borderRadius:"0.5rem",
                    marginBottom:"1rem",
                    fontSize:"0.85rem",
                    color: feedback.includes("✓") ? "#22c55e" : "#ef4444",
                    fontWeight:"600",
                    border: feedback.includes("✓")
                        ? "1px solid rgba(34,197,94,0.3)"
                        : "1px solid rgba(239,68,68,0.3)"
                }}>
                    {feedback}
                </div>
            )}

            <div style={{display:"flex", flexDirection:"column", gap:"0.5rem", marginBottom:"1rem"}}>
                <button
                    onClick={() => setShowHint(!showHint)}
                    style={{
                        background:"rgba(59,130,246,0.2)",
                        border:"1px solid rgba(59,130,246,0.3)",
                        color:"#3b82f6",
                        fontWeight:"700",
                        padding:"0.6rem 1rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer",
                        fontSize:"0.85rem"
                    }}
                >
                    <i className="fas fa-lightbulb" style={{marginRight:"6px"}}></i>
                    {showHint ? "Nascondi Hint" : "Mostra Hint (-50% punti)"}
                </button>

                {showHint && (
                    <div style={{
                        padding:"0.8rem",
                        background:"rgba(59,130,246,0.1)",
                        borderRadius:"0.5rem",
                        fontSize:"0.8rem",
                        color:"#94a3b8",
                        border:"1px solid rgba(59,130,246,0.3)"
                    }}>
                        💡 {problem.hint}
                    </div>
                )}

                <div style={{display:"flex", gap:"0.5rem"}}>
                    <button
                        onClick={checkUserFix}
                        disabled={showSolution}
                        style={{
                            flex:1,
                            background: showSolution
                                ? "rgba(255,255,255,0.1)"
                                : "linear-gradient(135deg,#22c55e,#16a34a)",
                            border:"none",
                            color:"#fff",
                            fontWeight:"700",
                            padding:"0.6rem 1rem",
                            borderRadius:"0.5rem",
                            cursor: showSolution ? "not-allowed" : "pointer",
                            fontSize:"0.85rem",
                            opacity: showSolution ? 0.5 : 1
                        }}
                    >
                        <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica Fix
                    </button>

                    <button
                        onClick={showCorrectSolution}
                        disabled={showSolution}
                        style={{
                            flex:1,
                            background: showSolution
                                ? "rgba(255,255,255,0.1)"
                                : "linear-gradient(135deg,#facc15,#ca8a04)",
                            border:"none",
                            color: showSolution ? "#fff" : "#000",
                            fontWeight:"700",
                            padding:"0.6rem 1rem",
                            borderRadius:"0.5rem",
                            cursor: showSolution ? "not-allowed" : "pointer",
                            fontSize:"0.85rem",
                            opacity: showSolution ? 0.5 : 1
                        }}
                    >
                        <i className="fas fa-eye" style={{marginRight:"6px"}}></i>
                        {showSolution ? "Soluzione" : "Mostra (-50% punti)"}
                    </button>
                </div>
            </div>

            {showSolution && (
                <div style={{
                    padding:"0.8rem",
                    background:"rgba(239,68,68,0.1)",
                    borderRadius:"0.5rem",
                    marginBottom:"0.5rem",
                    fontSize:"0.8rem",
                    color:"#ef4444",
                    border:"1px solid rgba(239,68,68,0.3)"
                }}>
                    <i className="fas fa-bug" style={{marginRight:"6px"}}></i>
                    <strong>Errore:</strong> {problem.error}
                </div>
            )}
        </div>
    );
}